import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Text, ToggleButton, ToggleButtonGroup, Tooltip, TooltipTrigger } from '@launchpad-ui/components';

import { Granularity, TimeRangeOption } from '../../../../types';

import styles from './PickerBase.module.css';

type TimeRangeButtonGroupProps = {
  selectedKey: TimeRangeOption;
  handlePress: (nextTimeRange: TimeRangeOption) => void;
  granularities: Granularity[];
};

export function TimeRangeButtonGroup({ selectedKey, handlePress, granularities }: TimeRangeButtonGroupProps) {
  const hasHourly = granularities.includes(Granularity.HOURLY);
  const hasDaily = granularities.includes(Granularity.DAILY);
  const hasMonthly = granularities.includes(Granularity.MONTHLY);

  return (
    <ToggleButtonGroup selectionMode="single" selectedKeys={selectedKey ? [selectedKey] : undefined}>
      <>
        {hasHourly && (
          <ToggleButton
            aria-label={msg('billing.usageControls.threeDays')}
            id={TimeRangeOption.THREE_DAY}
            className={styles.usageButton}
            onPress={() => handlePress(TimeRangeOption.THREE_DAY)}
          >
            <Text>
              <Message id="billing.usageControls.threeDays" />
            </Text>
          </ToggleButton>
        )}
        {hasDaily && (
          <>
            <ToggleButton
              aria-label={msg('billing.usageControls.thirtyDays')}
              id={TimeRangeOption.THIRTY_DAY}
              className={styles.usageButton}
              onPress={() => handlePress(TimeRangeOption.THIRTY_DAY)}
            >
              <Text>
                <Message id="billing.usageControls.thirtyDays" />
              </Text>
            </ToggleButton>
            <TooltipTrigger>
              <ToggleButton
                aria-label={msg('billing.usageControls.mtd')}
                id={TimeRangeOption.MONTH_TO_DATE}
                className={styles.usageButton}
                onPress={() => handlePress(TimeRangeOption.MONTH_TO_DATE)}
              >
                <Text>
                  <Message id="billing.usageControls.mtd" />
                </Text>
              </ToggleButton>
              <Tooltip placement="bottom">
                <Message id="billing.usageControls.monthToDate" />
              </Tooltip>
            </TooltipTrigger>
          </>
        )}
        {hasMonthly && (
          <ToggleButton
            aria-label={msg('billing.usageControls.threeMonths')}
            id={TimeRangeOption.THREE_MONTH}
            className={styles.usageButton}
            onPress={() => handlePress(TimeRangeOption.THREE_MONTH)}
          >
            <Text>
              <Message id="billing.usageControls.threeMonths" />
            </Text>
          </ToggleButton>
        )}
      </>
    </ToggleButtonGroup>
  );
}
